var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"humidity-content"},[_c('div',{staticClass:"title"},[_vm._v("Humidity")]),_c('div',{staticClass:"value"},[_vm._v("80%")])])
}]

export { render, staticRenderFns }